import React, {useState} from "react";
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';
import FacebookIcon from '@material-ui/icons/Facebook';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import RoomIcon from '@material-ui/icons/Room';
import CallIcon from '@material-ui/icons/Call';
import EmailIcon from '@material-ui/icons/Email';
import { Box, Container, Row, Column, FooterLink, Heading, Dude } from "./Style";
import { CopyToClipboard } from 'react-copy-to-clipboard'
  
const Footer = ({refFooter}) => {

  const [value, setValue] = useState('oleh.khas1122@gmail.com')
  const [value1, setValue1] = useState('081292677993')
  const [copi, setCopi] = useState(false)
  const [copi1, setCopi1] = useState(false)

  return (
    <main ref={refFooter}>
    <Box>
      <Container>
        <Row>
          <Column>
            <Heading>Contact Us</Heading>
            <FooterLink href="https://www.google.com/maps/dir//Toko+oleh-oleh,+Komplek+indowaneka+blok+intan+4+no+78+kel+temberan,+Air+Itam,+Bukit+Intan,+Kota+Pangkal+Pinang,+Kepulauan+Bangka+Belitung+33684/@-2.140661,106.157723,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x2e22b91053d279a5:0xc92e4019e6b6e4cf!2m2!1d106.1599117!2d-2.140661!3e0"><RoomIcon/><i className="fab fa-room">Alamat</i></FooterLink>
            <Dude><CallIcon/><i className="fab fa-call">No.Tlp</i></Dude>
            <input style={{background: 'black', color: 'white', border: 0, fontSize:14, marginBottom: 15}} value={value1} onChange={({terget: {value1}}) => setValue1(value1)}/>
            <CopyToClipboard text={value1}
            onCopy={() => setCopi1(true)}>
              <button>Copy</button>
            </CopyToClipboard>
            {copi1 ? <span style={{color: 'green'}}>Copy</span>: null}
            <Dude><EmailIcon/><i className="fab fa-email">Email</i></Dude>
            <input style={{background: 'black', color: 'white', border: 0, fontSize:14, marginBottom: 15}} value={value} onChange={({terget: {value}}) => setValue(value)}/>
            <CopyToClipboard text={value}
            onCopy={() => setCopi(true)}>
              <button>Copy</button>
            </CopyToClipboard>
            {copi ? <span style={{color: 'green'}}>Copy</span>: null}

          </Column>
          <Column>
            <Heading>Social Media</Heading>
            <FooterLink href="https://www.facebook.com/Havana-SNACK-106647237383680/">
              <FacebookIcon/>
              <i className="fab fa-facebook-f">
                <span style={{ marginLeft: "10px" }}>
                  Facebook
                </span>
              </i>
            </FooterLink>
            <FooterLink href="https://www.instagram.com/oleh_olehbangka/">
              <InstagramIcon/>
              <i className="fab fa-instagram">
                <span style={{ marginLeft: "10px" }}>
                  Instagram
                </span>
              </i>
            </FooterLink>
            <FooterLink href="https://twitter.com/havanaSnack">
              <TwitterIcon/>
              <i className="fab fa-twitter">
                <span style={{ marginLeft: "10px" }}>
                  Twitter
                </span>
              </i>
            </FooterLink>
            <FooterLink href="https://bit.ly/3nu20Rj">
            <WhatsAppIcon/>
              <i className="fab fa-whatsApp">
                <span style={{ marginLeft: "10px" }}>
                  Whatshapp
                </span>
              </i>
            </FooterLink>
          </Column>
        </Row>
      </Container>
    </Box>
    </main>
  );
};
export default Footer;